import { type IMapWidget } from '../../IMapWidget.ts';
import {
  type IMapLayer,
  type IMapLayerIdentify,
} from '../../layers/MapLayer.ts';

/**
 * Specializzazione di un `IMapLayer` con interrogazione (identify)
 * abilitata.
 */
export interface IMapIdentifyLayer extends IMapLayer {
  identify: IMapLayerIdentify;
}

/**
 * Rappresenta un layer con interrogazione abilitata, con il relativo
 * indice nella lista dei layer.
 */
export interface IdentifyLayerInfo {
  layer: IMapIdentifyLayer;
  index: number;
}

/**
 * Filtra i layer con interrogazione (identify) abilitata
 * e ritorna indice e config per ciascuno.
 */
export function getIdentifyLayersInfo(widget: IMapWidget): IdentifyLayerInfo[] {
  return (widget.layers ?? [])
    .map((layer, index) => ({ layer, index }))
    .filter(
      (entry): entry is IdentifyLayerInfo => !!entry.layer.identify?.enabled,
    );
}
